import { render } from "./UserList.vue?vue&type=template&id=44d2bb3a&scoped=true"
import script from "./UserList.vue?vue&type=script&lang=js"
export * from "./UserList.vue?vue&type=script&lang=js"

import "./UserList.vue?vue&type=style&index=0&id=44d2bb3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44d2bb3a"]])

export default __exports__